import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-htmlportfolio',
  templateUrl: './htmlportfolio.component.html',
  styleUrls: ['./htmlportfolio.component.css']
})
export class HtmlPortfolioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
